import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import TopUpRequestTable from '../../../components/tables/TopUpRequestTable';

const formatDate = (date) => date.toISOString().split('T')[0];

const parseDate = (value) => {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const retailerTopUpRequests = [
  {
    id: 'RTRD0001',
    userName: 'Green Mart Services',
    date: '2025-10-29',
    amount: 18500,
    mode: 'UPI',
    orderId: 'DTR123001',
    utr: 'RTRDUTR51101',
    bank: 'HDFC Bank',
    transDate: '2025-10-29',
    remark: 'Weekly wallet refill',
    reason: '',
    parentId: { mobile: 'DIS-9822334455' },
    userId: { mobile: 'RET-9898001122' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'N/A',
    time: '09:45 AM',
  },
  {
    id: 'RTRD0002',
    userName: 'BrightPay Services',
    date: '2025-10-28',
    amount: 26500,
    mode: 'NEFT',
    orderId: 'DTR123002',
    utr: 'RTRDUTR51102',
    bank: 'Axis Bank',
    transDate: '2025-10-27',
    remark: 'Festival spike',
    reason: '',
    parentId: { mobile: 'DIS-9766554433' },
    userId: { mobile: 'RET-9812233445' },
    status: 'Approved',
    approvedBy: 'Distributor Ops',
    approvedDate: '2025-10-28',
    recorn: 'Yes',
    time: '04:20 PM',
  },
  {
    id: 'RTRD0003',
    userName: 'Allied Digital Booth',
    date: '2025-10-26',
    amount: 9600,
    mode: 'IMPS',
    orderId: 'DTR123003',
    utr: 'RTRDUTR51103',
    bank: 'ICICI Bank',
    transDate: '2025-10-26',
    remark: 'AEPS settlements',
    reason: 'Mismatch in reference details',
    parentId: { mobile: 'DIS-9544221100' },
    userId: { mobile: 'RET-9833445566' },
    status: 'Rejected',
    approvedBy: 'Distributor Ops',
    approvedDate: '2025-10-27',
    recorn: 'No',
    time: '12:35 PM',
  },
  {
    id: 'RTRD0004',
    userName: 'Metro Express Retail',
    date: '2025-10-24',
    amount: 31800,
    mode: 'RTGS',
    orderId: 'DTR123004',
    utr: 'RTRDUTR51104',
    bank: 'State Bank of India',
    transDate: '2025-10-24',
    remark: 'Bulk recharge demand',
    reason: '',
    parentId: { mobile: 'DIS-9332211445' },
    userId: { mobile: 'RET-9899112233' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'Awaiting',
    time: '06:15 PM',
  },
  {
    id: 'RTRD0005',
    userName: 'Sunrise Kiosk',
    date: '2025-10-22',
    amount: 14200,
    mode: 'Cash Deposit',
    orderId: 'DTR123005',
    utr: 'RTRDUTR51105',
    bank: 'Bank of Baroda',
    transDate: '2025-10-21',
    remark: 'Counter cash addition',
    reason: '',
    parentId: { mobile: 'DIS-9011223344' },
    userId: { mobile: 'RET-9811003344' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'Verification',
    time: '02:05 PM',
  },
  {
    id: 'RTRD0006',
    userName: 'TapTop Retail',
    date: '2025-10-20',
    amount: 20600,
    mode: 'UPI',
    orderId: 'DTR123006',
    utr: 'RTRDUTR51106',
    bank: 'Yes Bank',
    transDate: '2025-10-20',
    remark: 'Wallet replenishment',
    reason: '',
    parentId: { mobile: 'DIS-9400112233' },
    userId: { mobile: 'RET-9844556677' },
    status: 'Approved',
    approvedBy: 'Distributor Ops',
    approvedDate: '2025-10-20',
    recorn: 'Yes',
    time: '11:10 AM',
  },
  {
    id: 'RTRD0007',
    userName: 'ConnectPay Booth',
    date: '2025-10-18',
    amount: 8700,
    mode: 'IMPS',
    orderId: 'DTR123007',
    utr: 'RTRDUTR51107',
    bank: 'IDFC First Bank',
    transDate: '2025-10-18',
    remark: 'Unexpected payouts',
    reason: '',
    parentId: { mobile: 'DIS-9887766554' },
    userId: { mobile: 'RET-9877889900' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'N/A',
    time: '03:50 PM',
  },
  {
    id: 'RTRD0008',
    userName: 'PaySwift Corner',
    date: '2025-10-17',
    amount: 39800,
    mode: 'NEFT',
    orderId: 'DTR123008',
    utr: 'RTRDUTR51108',
    bank: 'Kotak Mahindra Bank',
    transDate: '2025-10-16',
    remark: 'Monthly target top-up',
    reason: 'Bank proof pending',
    parentId: { mobile: 'DIS-9777002211' },
    userId: { mobile: 'RET-9866110099' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'Follow-up',
    time: '05:25 PM',
  },
];

const identifyDateRange = (records = []) => records.reduce(
  (range, record) => {
    const requestDate = parseDate(record?.date) || parseDate(record?.transDate);

    if (!requestDate) {
      return range;
    }

    const next = { ...range };

    if (!next.min || requestDate < next.min) {
      next.min = requestDate;
    }

    if (!next.max || requestDate > next.max) {
      next.max = requestDate;
    }

    return next;
  },
  { min: null, max: null }
);

const createDefaultFilters = (records) => {
  const range = identifyDateRange(records);
  const today = formatDate(new Date());

  return {
    fromDate: range.min ? formatDate(range.min) : today,
    toDate: range.max ? formatDate(range.max) : today,
    searchValue: '',
    pageNumber: 0,
    pageSize: 10,
  };
};

const TopUpRequestFromRetailer = () => {
  const defaultFilters = useMemo(() => createDefaultFilters(retailerTopUpRequests), []);

  const [filters, setFilters] = useState(defaultFilters);
  const [allRequests, setAllRequests] = useState(retailerTopUpRequests);
  const [requestsData, setRequestsData] = useState([]);
  const [meta, setMeta] = useState({
    totalRecords: 0,
    totalPages: 0,
    currentPage: 0,
    pageSize: defaultFilters.pageSize,
  });

  useEffect(() => {
    const from = parseDate(filters.fromDate);
    const to = parseDate(filters.toDate);
    const normalizedSearch = filters.searchValue?.trim().toLowerCase() ?? '';

    const filterByDate = (request) => {
      const requestDate = parseDate(request?.date) || parseDate(request?.transDate);

      if (!from && !to) {
        return true;
      }

      if (!requestDate) {
        return false;
      }

      if (from && requestDate < from) {
        return false;
      }

      if (to) {
        const normalizedTo = new Date(to);
        normalizedTo.setHours(23, 59, 59, 999);
        if (requestDate > normalizedTo) {
          return false;
        }
      }

      return true;
    };

    const includesSearchValue = (request) => {
      if (!normalizedSearch) {
        return true;
      }

      const searchInValue = (value) => {
        if (value === null || value === undefined) {
          return false;
        }

        if (typeof value === 'object') {
          return Object.values(value).some((nested) => searchInValue(nested));
        }

        return String(value).toLowerCase().includes(normalizedSearch);
      };

      return Object.values(request).some(searchInValue);
    };

    const filtered = allRequests.filter((request) => filterByDate(request) && includesSearchValue(request));

    const totalRecords = filtered.length;
    const totalPages = totalRecords > 0 ? Math.ceil(totalRecords / filters.pageSize) : 0;
    const lastPageIndex = Math.max(totalPages - 1, 0);
    const currentPage = Math.min(Math.max(filters.pageNumber, 0), lastPageIndex);
    const startIndex = currentPage * filters.pageSize;
    const pageSlice = filtered.slice(startIndex, startIndex + filters.pageSize);

    setRequestsData(pageSlice);
    setMeta({
      totalRecords,
      totalPages,
      currentPage,
      pageSize: filters.pageSize,
    });

    if (currentPage !== filters.pageNumber) {
      setFilters((prev) => ({ ...prev, pageNumber: currentPage }));
    }
  }, [allRequests, filters]);

  const handleDateChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      pageNumber: 0,
    }));
  };

  const handleSearch = (value) => {
    setFilters((prev) => ({
      ...prev,
      searchValue: value,
      pageNumber: 0,
    }));
  };

  const handleTableDataChange = (updatedPageData = []) => {
    if (!Array.isArray(updatedPageData)) {
      return;
    }

    setAllRequests((prev) => {
      const next = [...prev];
      const indexById = new Map(next.map((item, index) => [item.id, index]));

      updatedPageData.forEach((item) => {
        if (!item || !item.id) {
          return;
        }

        if (indexById.has(item.id)) {
          const idx = indexById.get(item.id);
          next[idx] = { ...next[idx], ...item };
        } else {
          next.unshift(item);
        }
      });

      return next;
    });
  };

  const handlePageChange = (pageNumber) => {
    setFilters((prev) => ({
      ...prev,
      pageNumber,
    }));
  };

  const handlePageSizeChange = (pageSize) => {
    setFilters((prev) => ({
      ...prev,
      pageSize,
      pageNumber: 0,
    }));
  };

  return (
    <Container fluid>
      <TopUpRequestTable
        data={requestsData}
        loading={false}
        pagination={{
          totalRecords: meta.totalRecords,
          pageSize: filters.pageSize,
          currentPage: meta.currentPage,
          totalPages: meta.totalPages,
        }}
        onDataChange={handleTableDataChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        searchValue={filters.searchValue}
        onSearch={handleSearch}
        fromDate={filters.fromDate}
        toDate={filters.toDate}
        onDateChange={handleDateChange}
        allowCreateButton={false}
        denseRows={true}
      />
    </Container>
  );
};

export default TopUpRequestFromRetailer;

